import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendPerformanceCenterCustomerResource,
  BackendQueryCustomerResourceArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query CustomerResource($customerId: ID!, $resourceId: ID) {
    customerResource(customerId: $customerId, resourceId: $resourceId) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

type Variables = BackendQueryCustomerResourceArgs;
type Result = BackendPerformanceCenterCustomerResource[];

export const queryCustomerResource = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data)?.[0];
};
